import React, { useEffect } from 'react';
import './index.scss';
import { data1 } from './staticData';
import bumenPng from 'static/imgs/banner20240125.png';
const CompanyGovernance: React.FC = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className='company-info-wrap'>
      <h2 className='title'>公司治理概要</h2>
      <h3 className='sub_title'>持股比例在5%以上的股东及其持股情况</h3>
      <div className='box_4'>
        <div className='box_4_header'>
          <div className='header_item'>序号</div>
          <div className='header_item body_item_border'>股东名称</div>
          <div className='header_item'>持股比例</div>
        </div>

        {data1.map((item, index) => (
          <div className='box_4_body' key={index}>
            <div className='body_item'>{item.id}</div>
            <div className='body_item body_item_border'>{item.title}</div>
            <div className='body_item'>{item.value}</div>
          </div>
        ))}
      </div>
      <h3 className='sub_title'>近五年股东会决议</h3>
      <div className='box_3'>
       <p className='p_box'>
          <a
            target='_blank'
            href='https://img03.az.jd.com/ins-user-m/develop/website/pdf/京东安联2023年股东会决议.pdf'
            className='link'
            rel='noopener noreferrer'
          >
            <span>2023年股东会决议</span>
          </a>
        </p>
        <p className='p_box'>
          <a
            target='_blank'
            href='https://img03.az.jd.com/ins-user-m/develop/website/pdf/2022年股东会决议_20221115.pdf'
            className='link'
            rel='noopener noreferrer'
          >
            <span>2022年股东会决议</span>
          </a>
        </p>
        <p className='p_box'>
          <a
            target='_blank'
            href='https://img03.az.jd.com/ins-user-m/develop/website/pdf/2021年股东会决议.pdf'
            className='link'
            rel='noopener noreferrer'
          >
            <span>2021年股东会决议</span>
          </a>
        </p>
        <p className='p_box'>
          <a
            target='_blank'
            href='https://img03.az.jd.com/ins-user-m/develop/website/pdf/2020年股东会决议.pdf'
            className='link'
            rel='noopener noreferrer'
          >
            <span>2020年股东会决议</span>
          </a>
        </p>
        <p className='p_box'>
          <a
            target='_blank'
            href='https://img03.az.jd.com/ins-user-m/develop/website/pdf/2019年股东会决议.pdf'
            className='link'
            rel='noopener noreferrer'
          >
            <span>2019年股东会决议</span>
          </a>
        </p>
      </div>

      <h3 className='sub_title'>董事简历</h3>
      <div className='box_3'>
        <a
          target='_blank'
          href='https://img03.az.jd.com/ins-user-m/develop/website/pdf/董事简历及其履职情况.pdf'
          className='link'
          rel='noopener noreferrer'
        >
          <span>董事简历及其履职情况</span>
        </a>
      </div>

      <h3 className='sub_title'>监事简历</h3>
      <div className='box_3'>
        <a
          target='_blank'
          href='https://img03.az.jd.com/ins-user-m/develop/website/pdf/监事简历及其履职情况.pdf'
          className='link'
          rel='noopener noreferrer'
        >
          <span>监事简历及其履职情况</span>
        </a>
      </div>

      <h3 className='sub_title'>高级管理人员简历、职责及其履职情况</h3>
      <div className='box_3'>
        <a
          target='_blank'
          href='https://img03.az.jd.com/ins-user-m/develop/website/pdf/高级管理人员简历职责及其履职情况20240125.pdf'
          className='link'
          rel='noopener noreferrer'
        >
          <span>高级管理人员简历、职责及其履职情况</span>
        </a>
      </div>

      <h3 className='sub_title'>公司部门设置情况</h3>
      <div className='box_3'>
        <img src={bumenPng} alt='图片' className='img_w100' />
      </div>
    </div>
  );
};

export default CompanyGovernance;
